import { filterMaybeArray } from "@examspark/common";
import {
  IDSK,
  QuerySearchArgs,
  SearchableResourceConnection,
} from "@examspark/types";

import { GraphQLAPI } from "../client";

/**
 * This folder should store and export all methods that make actual calls to
 * GraphQL endpoints. (ex: using `GraphQLAPI.client.query` or `gqlQuery`).
 */

export * as alert from "./alert";
export * as app from "./app";
export * as bank from "./bank";
export * as classroom from "./classroom";
export * as comment from "./comment";
export * as content from "./content";
export * as course from "./course";
export * as exam from "./exam";
export * as favorites from "./favorites";
export * as feedback from "./feedback";
export * as file from "./file";
export * as item from "./item";
export * as issue from "./issue";
export * as jobs from "./jobs";
export * as media from "./media";
export * as objective from "./objective";
export * as registration from "./app.registration";
export * as resource from "./resource";
export * as role from "./role";
export * as tags from "./tags";
export * as task from "./task";
export * as unit from "./unit";
export * as user from "./user";
export * as vocabulary from "./vocabulary";
export * as workspace from "./workspace";

/** Uses `searchUserResources` instead of `search`. */
export const paginatedSearch = async (params: {
  query: any;
  nextToken?: string;
}) => {
  const items: any[] = [];
  // console.log("query!", params.nextToken);

  if (params.nextToken) {
    params.query.variables.nextToken = params.nextToken;
  }
  const result: any = await GraphQLAPI.query(params.query);

  if (!result?.data?.searchUserResources?.items.length) {
    return items;
  } else {
    for (const item of result?.data?.searchUserResources.items ?? []) {
      items.push(item);
    }
  }

  if (result?.data?.searchUserResources.nextToken) {
    const next = await paginatedSearch({
      ...params,
      nextToken: result?.data?.searchUserResources.nextToken,
    });
    for (const nextItem of next) {
      items.push(nextItem);
    }
  }

  return items;
};

/** Uses `search` instead of `searchUserResources`. */
export const paginatedSearchNew = async (params: {
  query: any;
  nextToken?: string;
}) => {
  const items: any[] = [];
  // console.log("query!", params.nextToken);

  if (params.nextToken) {
    params.query.variables.nextToken = params.nextToken;
  }
  const result: any = await GraphQLAPI.query(params.query);

  if (!result?.data?.search?.items.length) {
    return items;
  } else {
    for (const item of result?.data?.search.items ?? []) {
      items.push(item);
    }
  }

  if (result?.data?.search.nextToken) {
    const next = await paginatedSearchNew({
      ...params,
      nextToken: result?.data?.search.nextToken,
    });
    for (const nextItem of next) {
      items.push(nextItem);
    }
  }

  return items;
};

export const paginatedBulkSearch = async function* (params: {
  query: {
    query: any;
    variables: QuerySearchArgs;
  };
  nextToken?: string;
}) {
  let nextToken: string | undefined = undefined;
  let page = 1;
  let total = 0;
  let pages = 0;

  do {
    console.log(`Fetching page ${page} of ${pages}`);
    page++;

    params.query.variables = { ...params.query.variables, nextToken };
    // console.log(nextToken);
    const result: Omit<SearchableResourceConnection, "items"> & {
      items?: string;
    } = (await GraphQLAPI.query(params.query)).data?.bulkSearch;
    total = result.total ?? 0;
    pages = Math.ceil(total / (params.query.variables.limit ?? 50));

    // console.log(result?.items?.length);
    const items = filterMaybeArray(JSON.parse(result?.items ?? "[]"));
    for (const item of items) {
      yield item as {
        _source: IDSK;
      };
    }

    nextToken = result.nextToken ?? undefined;
  } while (nextToken != null);
};
